import { render, staticRenderFns } from "./Warn.vue?vue&type=template&id=607d4d93&lang=pug"
import script from "./Warn.vue?vue&type=script&lang=js"
export * from "./Warn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports